<template>
  <div class="cal-container__header flex flex-1">
    <div class="cal-container__header--left flex">
      <h3>{{showDate}}</h3>
    </div>
    <div class="cal-container__header--right">
      <button @click="$emit('today')" :class="[{inactive: !isNotThisWeek}, 'no-print']">{{ $t('repitition.today')}}</button>
      <button class="icon-arrow-left4 no-print" @click="$emit('prevWeek')"></button>
      <button class="icon-arrow-right4 no-print" @click="$emit('nextWeek')"></button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    props: {
      date: {
        default: () => moment()
      },
      calview: {},
      locale: {
        default: 'en'
      },
      isNotThisWeek: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      showDate () {
        const self = this
        try {
          if (self.locale === 'nn' || self.locale === 'nb') {
            return moment(this.date).locale(self.locale).format('MMMM YYYY')
          }
          return moment(this.date)._d.toLocaleDateString(self.locale, {month: 'long', year: 'numeric'})
        } catch (e) {
          return moment(this.date).format('LL')
        }
      }
    }
  }
</script>

<style scoped>
  h3 {
    opacity: .54;
    text-transform: capitalize;
    font-size: 20px;
    font-weight: 400;
  }

  .cal-container__header {
    margin-bottom: 10px;
    align-items: stretch;
    justify-content: space-between;
  }

  .cal-container__header--right {
    display: flex;
  }

  .cal-container__header--right > button {
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// FullCalHeader.vue?68a01ecd